<template>
  <crud-layout :title="title" :subtitle="subtitle">
    <template v-slot:list>
      <csv-etiquetas-list ref="list" :company-id="companyId" :deposito-id="depositoId" @flash="onFlash" />
    </template>

    <snackbar v-model="flash" :color="flashColor" />
  </crud-layout>
</template>

<script>
import CsvEtiquetasList from '../CsvEtiquetasList'
import UserConfigurationProvider from '../../../../user-configuration/providers/UserConfigurationProvider'
import CompanyProvider from '../../../../base/providers/CompanyProvider'
import DepositoProvider from '../../../../deposito/providers/DepositoProvider'
import { CrudLayout, Snackbar } from '@dracul/common-frontend'

export default {
  name: 'CsvEtiquetasCrud',
  components: { CrudLayout, Snackbar, CsvEtiquetasList },
  data() {
    return {
      title: 'media.file.csvEtiquetas.title',
      subtitle: 'media.file.csvEtiquetas.listTitle',
      flash: null,
      flashColor: 'success',
      depositoId: null
    }
  },
  computed: {
    companyId() {
      return this.$store.state.user.companyId || null
    }
  },
  watch: {
    companyId: {
      handler(companyId) {
        if (companyId) this.resolveDeposito()
      },
      immediate: true
    }
  },
  mounted() {
    this.resolveDeposito()
  },
  methods: {
    async ensureCompanyId() {
      let companyId = this.companyId
      if (companyId) return companyId

      try {
        const response = await CompanyProvider.getMyCompanyId()
        companyId = response?.data?.me?.companyId || null
        if (companyId) {
          // Persistir en el store para que el resto de la app también lo tenga
          this.$store.state.user.companyId = companyId
        }
      } catch (e) {
        // Silenciar aquí, se manejará en resolveDeposito si sigue sin companyId
      }

      return companyId
    },
    async resolveDeposito() {
      let companyId = await this.ensureCompanyId()
      try {
        const res = await UserConfigurationProvider.getUserConfiguration(true)
        const config = res?.data?.userConfigurationGet
        const selected = config?.depositoIdSeleccionado
        this.depositoId = selected ? String(selected) : null
        if (!companyId && this.depositoId) {
          const depRes = await DepositoProvider.findDeposito(this.depositoId)
          const deposito = depRes?.data?.depositoFind
          if (deposito?.companyId) {
            companyId = String(deposito.companyId)
            this.$store.state.user.companyId = companyId
          }
        }
        if (companyId && this.depositoId && this.$refs.list) {
          this.$nextTick(() => this.$refs.list.fetch())
        }
      } catch (e) {
        this.flash = this.$t('media.file.csvEtiquetas.errorConfig')
        this.flashColor = 'error'
      }
    },
    onFlash(payload) {
      if (payload && typeof payload === 'object' && payload.message != null) {
        this.flash = payload.message
        this.flashColor = payload.color || 'success'
      } else {
        this.flash = payload
        this.flashColor = 'success'
      }
    }
  }
}
</script>
